import { Book as Book_kojaro } from './Book.kojaro';
import { Book as Book_zoomg } from './Book.zoomg';
import { Book as Book_zoomit } from './Book.zoomit';

const IconRenderer = () => {
  switch (process.env.NEXT_PUBLIC_ICON_SYSTEM) {
    case 'kojaro':
      return Book_kojaro;

    case 'zoomg':
      return Book_zoomg;

    default:
      return Book_zoomit;
  }
};

export const Book = IconRenderer();
